import axios from 'axios';

// Aman untuk Vite atau CRA:
// 1. VITE_BACKEND_URL untuk Vite
// 2. REACT_APP_BACKEND_URL untuk CRA
const API_BASE =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL ||
  'http://localhost:5000';

console.log('API_BASE:', API_BASE);

const api = axios.create({
  baseURL: API_BASE + '/api',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('❌ API Response Error:', error.response?.data || error.message);
    return Promise.reject(error.response?.data || error);
  }
);

export const contactAPI = {
  submitContact: async (data) => {
    return await api.post('/contacts', data);
  }
};

export default api;
